// src/components/player/MusicPlayerIndicator.jsx
import React from 'react';
import { useMusicPlayerStore } from '../../stores/useUIStore'; // 🟢 1. Importamos el store

const MusicPlayerIndicator = () => {
  // 🟢 2. Obtenemos el estado y las acciones del store
  const currentTrack = useMusicPlayerStore((state) => state.currentTrack);
  const isPlaying = useMusicPlayerStore((state) => state.isPlaying);
  const isPlayerVisible = useMusicPlayerStore((state) => state.isPlayerVisible);
  const showPlayer = useMusicPlayerStore((state) => state.showPlayer);

  // Solo se muestra si hay una canción sonando y el reproductor principal está oculto
  if (!currentTrack || !isPlaying || isPlayerVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up">
      <button
        onClick={showPlayer}
        className="flex items-center space-x-3 p-2 bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-full shadow-lg hover:scale-105 transition-transform duration-300"
        title={`Reproduciendo: ${currentTrack.title} - ${currentTrack.artist}`}
      >
        <img
          src={currentTrack.albumArtUrl}
          alt={currentTrack.title}
          className="w-10 h-10 rounded-full object-cover border-2 border-blue-400"
        />
        <div className="flex flex-col items-start">
          <span className="text-sm font-bold truncate max-w-[150px]">
            {currentTrack.title}
          </span>
          <span className="text-xs text-blue-300 animate-pulse">
            Control music here
          </span>
        </div>
        <div className="flex space-x-1 items-end h-4 pr-2">
          <span
            className="w-1 bg-blue-400 animate-pulse"
            style={{ height: '100%', animationDelay: '0s' }}
          ></span>
          <span
            className="w-1 bg-blue-400 animate-pulse"
            style={{ height: '50%', animationDelay: '0.2s' }}
          ></span>
          <span
            className="w-1 bg-blue-400 animate-pulse"
            style={{ height: '80%', animationDelay: '0.4s' }}
          ></span>
        </div>
      </button>
    </div>
  );
};

export default MusicPlayerIndicator;
